var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.operatingAirlines.length)?_c('div',[_c('div',{staticClass:"text-caption mr-1"},[_vm._v(_vm._s(_vm.$t('flights.operated_by')))]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.operatingAirlines.map(({name}) => name).join(', '))+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }